export enum ManualNettingAction {
  NET,
  CLEAR,
  DISABLE,
}

export namespace ManualNettingAction {
  let elements = [ManualNettingAction.NET, ManualNettingAction.CLEAR, ManualNettingAction.DISABLE];
  let alias = "com.bcdfx.api.servicerequest.ManualNettingAction";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
